<template>
  <main class="grid-wrapper">
    <div class="column-span-3 flex-column align-start">
      <p class="-stb">Unit Details</p>
      <p class="-xstr">Update your unit details here</p>
    </div>
    <hr class="column-span-3 hr-form" />

    <section class="column-span-3 grid-wrapper">
      <UpdateUnitDetailsForm />
    </section>
  </main>
</template>

<script>
import UpdateUnitDetailsForm from "../../components/forms/projects/UpdateUnitDetailsForm.vue";
export default {
  components: {
    UpdateUnitDetailsForm,
  },
};
</script>

<style scoped>
.grid-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.column-span-3 {
  grid-column: span 3;
  width: 100%;
  justify-items: start;
}
</style>
